document.addEventListener("DOMContentLoaded", () => {
  const menuToggle = document.querySelector("#menuToggle");
  const navContainer = document.querySelector(".nav-primary");

  if (null !== typeof menuToggle) {
    menuToggle.addEventListener("click", event => {
      event.preventDefault();
      menuToggle.classList.toggle("is-active");
      navContainer.classList.toggle("visible");
    });
  }

  // add target="_blank" to social icons
  const socialIcon = document.querySelectorAll(".icon .wp-block-button__link");
  const icons = [...socialIcon];
  icons.forEach(element => {
    if (!element.parentNode.classList[2].includes("newsletter")) {
      element.setAttribute("target", "_blank");
    }
  });
});
